import React from "react"
import { Link } from "gatsby"

const useCases = [
  {
    emoji: "🔍",
    label: "Looking to join",
    headline: "Find communities worth joining",
    body:
      "Tired of dead Discord servers and ghost-town Slack groups? Every listing on Hive Index includes member counts, features, and platform details so you can spot the active ones before you commit.",
    cta: { text: "Browse communities", href: "/communities/" },
  },
  {
    emoji: "🏗️",
    label: "Building a community",
    headline: "Get your community discovered",
    body:
      "People are actively searching Hive Index for communities like yours right now. A free listing gives you a dedicated, high-traffic page, feature tags, and analytics showing exactly who is looking your way.",
    cta: { text: "List for free", href: "/submit/" },
  },
  {
    emoji: "🗺️",
    label: "Researching the space",
    headline: "The most complete map of online communities",
    body:
      "Whether you are writing an article, building a product, or doing market research, Hive Index gives you structured data on thousands of communities across every major platform and topic area.",
    cta: { text: "Explore topics", href: "/topics/" },
  },
]

const UseCaseSection = () => {
  return (
    <section
      className="my-14 sm:my-16 lg:my-20 reveal"
      aria-labelledby="usecase-heading"
    >
      <div className="text-center max-w-2xl mx-auto mb-10">
        <p className="section-eyebrow">Who uses Hive Index</p>
        <h2
          id="usecase-heading"
          className="mt-2 text-2xl font-extrabold text-gray-900 tracking-tight sm:text-3xl"
        >
          Built for seekers and builders alike
        </h2>
      </div>

      <ul
        className="grid grid-cols-1 gap-6 sm:grid-cols-3"
        aria-label="Use cases for Hive Index"
      >
        {useCases.map((uc) => (
          <li
            key={uc.label}
            className="bg-white rounded-xl border border-gray-100 shadow-sm p-6 sm:p-8 flex flex-col"
          >
            <span className="text-3xl" aria-hidden="true">
              {uc.emoji}
            </span>
            <p className="mt-4 section-eyebrow">{uc.label}</p>
            <h3 className="mt-2 text-lg font-extrabold text-gray-900 leading-snug">
              {uc.headline}
            </h3>
            <p className="mt-3 text-sm sm:text-base text-gray-600 leading-relaxed flex-1">
              {uc.body}
            </p>
            <Link
              to={uc.cta.href}
              className="mt-6 inline-block text-sm font-semibold text-rose-600 hover:text-rose-700 hover:underline"
            >
              {uc.cta.text} →
            </Link>
          </li>
        ))}
      </ul>
    </section>
  )
}

export default UseCaseSection
